import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const FilterIcon = props => {
  return (
    <Svg
      width={18}
      height={15}
      viewBox="0 0 18 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.354 4.25H1a.75.75 0 010-1.5h9.354a2.751 2.751 0 015.293 0H17a.75.75 0 010 1.5h-1.354a2.751 2.751 0 01-5.293 0zm1.396-.75a1.25 1.25 0 112.5 0 1.25 1.25 0 01-2.5 0zM7.646 12.25H17a.75.75 0 000-1.5H7.646a2.751 2.751 0 00-5.292 0H1a.75.75 0 000 1.5h1.354a2.751 2.751 0 005.292 0zM3.75 11.5a1.25 1.25 0 112.5 0 1.25 1.25 0 01-2.5 0z"
        fill="#001533"
      />
    </Svg>
  );
};

export default FilterIcon;
